export const LOCAL_SET_JOB_PHASES = 'LOCAL_SET_JOB_PHASES';
export const LOCAL_ADD_JOB_PHASE = 'LOCAL_ADD_JOB_PHASE';
export const LOCAL_DELETE_JOB_PHASE = 'LOCAL_DELETE_JOB_PHASE';
export const LOCAL_UPDATE_JOB_PHASE = 'LOCAL_UPDATE_JOB_PHASE';
